import { SfAppComponent } from '../sf/sf-app.component';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    @if (loadingData()) {
      <app-sd-progress-bar-a11y progressBarType="main" />
    }
    @if (!loadingData()) {
      <div class="td-sf-app-root">
        <router-outlet />
      </div>
    }
  `,
  styles: [
    `
      .td-sf-app-root {
        background-color: var(--appBackground);
        height: 100%;
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TdSfAppComponent extends SfAppComponent {}
